import React, { FunctionComponent } from 'react';
import {
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import resourceDownloadRequest from '../../../services/resources.service';
import { IResource } from '../../../interfaces/resource.interface';
import useStyles from './ResourceItem.styles';

type Props = {
  resource: IResource;
};

const ResourceItem: FunctionComponent<Props> = ({ resource }) => {
  const { directDownload, path, label } = resource;
  const classes = useStyles();
  const handleClick = async () => {
    if (directDownload) {
      await resourceDownloadRequest(path);
    } else {
      window.open(path, '_blank');
    }
  };
  return (
    <div className={classes.root} onClick={handleClick}>
      <ListItem component="button">
        <ListItemIcon>
          <AssignmentReturnedIcon className={classes.icon} />
        </ListItemIcon>
        <ListItemText primary={label} className={classes.label} />
      </ListItem>
    </div>
  );
};

export default ResourceItem;